"use client";

import { FormEvent, FunctionComponent, PropsWithChildren } from "react";
import { Wrapper } from "./form.styles";

export interface FormProps {
    /**
     * ID of the form.
     */
    id?: string;

    /**
     * Will display the form 50% transparent.
     */
    loading?: boolean | false;

    /**
     * A callback function which will be fired on submit.
     */
    onSubmit?: (event: FormEvent<HTMLFormElement>) => void;

    /**
     * Class name of the form.
     */
    className?: string;
}

export const Form: FunctionComponent<PropsWithChildren<FormProps>> = ({ id, loading, onSubmit, children, className }) => {
    return (
        <Wrapper id={id} loading={loading} onSubmit={onSubmit} className={className} noValidate>
            <fieldset disabled={loading ? true : false}>{children}</fieldset>
        </Wrapper>
    );
};
